export default "__VITE_ASSET__ewZ14Fwf__"